/** Linhas não vazias de `note_lines` / `registros`, na ordem gravada. */
export function normalizeLigacaoInformacoesLinhas(lines: string[] | null | undefined): string[] {
  if (!Array.isArray(lines)) return []
  return lines.map(s => (typeof s === 'string' ? s.trim() : String(s).trim())).filter(Boolean)
}
